import { CSSProperties, ReactElement, ReactNode } from 'react';
import {
  SContainer,
  SCard,
  STitle,
  SLink,
} from './TableSection.style';

type TableSectionProps = {
  children?: ReactNode;
  title: string;
  style?: CSSProperties;
  href?: string;
};

export const TableSection = ({ children, title, href, ...restProps }: TableSectionProps): ReactElement => (
  <SContainer {...restProps}>
    {href ? <SLink to={href}>{title}</SLink> : <STitle>{title}</STitle>}
    <SCard>{children}</SCard>
  </SContainer>
);
